import React from 'react'
import exams from "../../Assets/exam.png";
import './ExamBanner.css'
import { useNavigate} from 'react-router-dom';


function ExamBanner() {
const navigate = useNavigate();

const handleNavigate = () => navigate('exam-system');

  return (
    <div className='exam-banner-container'>
        <div className='exam-banner-layout'>
            <img src={exams} alt="" className='exam-banner-img'/>
                <h2 className='exam-banner-title'>AI-Powered Examinations Free Learning & Testing Tools</h2> 
                <p className='exam-banner-subtitle'>
                <strong>Cut grading time by 90%</strong> with instant evaluation and detailed performance analytics.
                </p>
            <button className='exam-banner-button' onClick={handleNavigate}>Start Exams</button> 
        </div>
    </div>
  )
}

export default ExamBanner
